import React from 'react';
import { Avatar, Icon } from '@socialchorus/shared-ui-components';
import { AssistantAction } from '../../assistant';
import { GenericCard } from '../../../models/chatbot/types';
import { convertToActionable } from '../../../lib/action-utils';
import { NavigationReferer } from '../../assistant/assistant-action';
import { convertLegacyAssistantUrl } from '../../../lib/url-utils';
import { noop } from '../noop';

interface GenericRefCardProps {
  card: GenericCard;
  onClick?: () => void;
}

const GenericRefCard: React.FC<GenericRefCardProps> = ({ card, onClick }) => {
  const actionable = convertToActionable(card.action, card.heading);

  // Only add pushState for legacy assistant routes (e.g., /sc4#service/4)
  // This enables proper back button functionality for assistant routes
  // For content links (e.g., /sc4#contents/89), we don't need pushState
  const isLegacyAssistantRoute =
    card.action.type === 'navigation' &&
    convertLegacyAssistantUrl(card.action.navigation.url) !== null;

  return (
    <AssistantAction
      action={actionable}
      className="ai-content__reference-card"
      pushState={
        isLegacyAssistantRoute
          ? { referer: NavigationReferer.INBOX }
          : undefined
      }
      onClick={onClick || noop}
    >
      <div className="ai-content__reference-card-content">
        <div className="ai-content__reference-card-body">
          {card.icon ? (
            <div className="ai-content__reference-avatar ai-content__reference-avatar--thumbnail">
              <Avatar imgSrc={card.icon} size="medium" shape="square" alt="" />
            </div>
          ) : (
            <div className="ai-content__reference-avatar">
              <Icon size={20} className="ai-content__reference-icon">
                link
              </Icon>
            </div>
          )}
          <div className="ai-content__reference-text">
            <h4 className="ai-content__reference-title">{card.heading}</h4>
            {card.subheading && (
              <p className="ai-content__reference-description">
                {card.subheading}
              </p>
            )}
          </div>
        </div>
      </div>
    </AssistantAction>
  );
};

export default GenericRefCard;
